import {
  AccountBalance,
  AccountBalanceWallet,
  Money,
} from '@mui/icons-material';

const ChannelIcon = (props) => {
  switch (props.channel?.toString().toUpperCase()) {
    case '2':
    case 'CASH':
      return <Money />;
    case '8':
    case 'BANK':
      return <AccountBalance />;
    case '32':
    case 'WALLET':
      return <AccountBalanceWallet />;
    default:
      return null;
  }
};

export default ChannelIcon;
